// src/paths.js

import { USER_TYPE } from "../constants/common";
import B12Callback from "../pages/Auth/B12Callback";
import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";
import RegisterKid from "../pages/Auth/RegisterKid";
import RegisterParent from "../pages/Auth/RegisterParent";
import AdaptedCourses from "../pages/B2B/School/AdaptedCourses";
import ClassroomReports from "../pages/B2B/School/ClassroomReports";
import GeneralReports from "../pages/B2B/School/GeneralReports";
import SchoolClassroomDetails from "../pages/B2B/School/SchoolClassroomDetails";
import SchoolClassrooms from "../pages/B2B/School/SchoolClassrooms";
import SchoolDashboard from "../pages/B2B/School/SchoolDashboard";
import SchoolImportStudents from "../pages/B2B/School/SchoolImportStudents";
import SchoolNotificationCenter from "../pages/B2B/School/SchoolNotificationCenter";
import SchoolStudentDetails from "../pages/B2B/School/SchoolStudentDetails";
import SchoolStudents from "../pages/B2B/School/SchoolStudents";
import SchoolTeacherDetails from "../pages/B2B/School/SchoolTeacherDetails";
import SchoolTeachers from "../pages/B2B/School/SchoolTeachers";
import TopTenStudents from "../pages/B2B/School/TopTenStudents";
import TopWeeklyStudents from "../pages/B2B/School/TopWeeklyStudents";
import StudentLearningArea from "../pages/B2B/Student/StudentLearningArea";
import StudentLessonGames from "../pages/B2B/Student/StudentLessonGames";
import StudentLessonQuestions from "../pages/B2B/Student/StudentLessonQuestions";
import StudentLessonVideo from "../pages/B2B/Student/StudentLessonVideo";
import StudentLevelProject from "../pages/B2B/Student/StudentLevelProject";
import StudentMyCodingArea from "../pages/B2B/Student/StudentMyCodingArea";
import StudentNotificationCenter from "../pages/B2B/Student/StudentNotificationCenter";
import StudentProfile from "../pages/B2B/Student/StudentProfile";
import StudentQuizzesHomeworks from "../pages/B2B/Student/StudentQuizzesHomeworks";
import SuperAdminDashboard from "../pages/B2B/SuperAdmin/SuperAdminDashboard";
import TeacherClassroomDetails from "../pages/B2B/Teacher/TeacherClassroomDetails";
import TeacherClassroomReports from "../pages/B2B/Teacher/TeacherClassroomReports";
import TeacherClassrooms from "../pages/B2B/Teacher/TeacherClassrooms";
import TeacherCodeReviewByLesson from "../pages/B2B/Teacher/TeacherCodeReviewByLesson";
import TeacherCodeReviewByStudent from "../pages/B2B/Teacher/TeacherCodeReviewByStudent";
import TeacherCreateQuizzesAndHomeworks from "../pages/B2B/Teacher/TeacherCreateQuizzesAndHomeworks";
import TeacherDashboard from "../pages/B2B/Teacher/TeacherDashboard";
import TeacherMaterialsResources from "../pages/B2B/Teacher/TeacherMaterialsResources";
import TeacherNotificationCenter from "../pages/B2B/Teacher/TeacherNotificationCenter";
import TeacherPlaygroundPythonIDE from "../pages/B2B/Teacher/TeacherPlaygroundPythonIDE";
import TeacherPlaygroundSmoothyIDE from "../pages/B2B/Teacher/TeacherPlaygroundSmoothyIDE";
import TeacherPlaygroundWebIDE from "../pages/B2B/Teacher/TeacherPlaygroundWebIDE";
import TeacherProjectReviewByLesson from "../pages/B2B/Teacher/TeacherProjectReviewByLesson";
import TeacherProjectReviewByStudent from "../pages/B2B/Teacher/TeacherProjectReviewByStudent";
import TeacherQuizzesAndHomeworks from "../pages/B2B/Teacher/TeacherQuizzesAndHomeworks";
import TeacherSkillsAssessment from "../pages/B2B/Teacher/TeacherSkillsAssessment";
import TeacherStudentDetails from "../pages/B2B/Teacher/TeacherStudentDetails";
import TeacherStudents from "../pages/B2B/Teacher/TeacherStudents";
import TeacherTopTenStudents from "../pages/B2B/Teacher/TeacherTopTenStudents";
import TeacherViewAndEditQuizzesAndHomeworks from "../pages/B2B/Teacher/TeacherViewAndEditQuizzesAndHomeworks";
import B2CPending from "../pages/Common/B2CPending";
import Certificates from "../pages/Common/Certificates";
import Courses from "../pages/Common/Courses";
import Home from "../pages/Common/Home";
import Pricing from "../pages/Common/Pricing";
import Privacy from "../pages/Common/Privacy";
import Terms from "../pages/Common/Terms";

export const UNAUTHENTICATED_ROUTES = [
  { path: "", element: Home },
  { path: "courses", element: Courses },
  { path: "certificates", element: Certificates },
  { path: "pricing", element: Pricing },
  { path: "privacy", element: Privacy },
  { path: "terms", element: Terms },
  { path: "login", element: Login },
  { path: "register", element: Register },
  { path: "register/kid", element: RegisterKid },
  { path: "register/parent", element: RegisterParent },
  { path: "b12/callback", element: B12Callback },
];

export const AUTHENTICATED_ROUTES = [
  /* student routes starts here  */
  {
    path: `${USER_TYPE.STUDENT.ROLE}/coding-area/:type?/:lessonID?/:difficulty?`,
    element: StudentMyCodingArea,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/learning-area`,
    element: StudentLearningArea,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/learning-area/lesson-video/:id/:lessonType`,
    element: StudentLessonVideo,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/learning-area/lesson-questions/:id`,
    element: StudentLessonQuestions,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/learning-area/lesson-game/:id`,
    element: StudentLessonGames,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/learning-area/levels-project/:id`,
    element: StudentLevelProject,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/quizzes-and-homeworks`,
    element: StudentQuizzesHomeworks,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/profile`,
    element: StudentProfile,
    roles: [USER_TYPE.STUDENT.ROLE],
  },
  {
    path: `${USER_TYPE.STUDENT.ROLE}/notifications-center`,
    element: StudentNotificationCenter,
    roles: [USER_TYPE.STUDENT.ROLE],
  },

  /* teacher routes starts here  */
  {
    path: USER_TYPE.TEACHER.ROLE,
    element: TeacherDashboard,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/my-classrooms`,
    element: TeacherClassrooms,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/students`,
    element: TeacherStudents,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/my-classrooms/:id`,
    element: TeacherClassroomDetails,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/skills-assessment`,
    element: TeacherSkillsAssessment,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/code-assessment-by-student`,
    element: TeacherCodeReviewByStudent,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/code-assessment-by-lesson`,
    element: TeacherCodeReviewByLesson,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/project-assessment-by-student`,
    element: TeacherProjectReviewByStudent,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/project-assessment-by-lesson`,
    element: TeacherProjectReviewByLesson,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/teacher-web-ide`,
    element: TeacherPlaygroundWebIDE,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/teacher-python-ide`,
    element: TeacherPlaygroundPythonIDE,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/teacher-smoothy-ide`,
    element: TeacherPlaygroundSmoothyIDE,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/my-classrooms/:id/:student_id`,
    element: TeacherStudentDetails,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/students/:id/:student_id`,
    element: TeacherStudentDetails,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/materials-resources`,
    element: TeacherMaterialsResources,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/quizzes-and-homeworks`,
    element: TeacherQuizzesAndHomeworks,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/quizzes-and-homeworks/create`,
    element: TeacherCreateQuizzesAndHomeworks,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/quizzes-and-homeworks/:quiz_id`,
    element: TeacherViewAndEditQuizzesAndHomeworks,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/classroom-reports`,
    element: TeacherClassroomReports,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/top-10-students`,
    element: TeacherTopTenStudents,
    roles: [USER_TYPE.TEACHER.ROLE],
  },
  {
    path: `${USER_TYPE.TEACHER.ROLE}/notifications-center`,
    element: TeacherNotificationCenter,
    roles: [USER_TYPE.TEACHER.ROLE],
  },

  /* school routes starts here  */
  {
    path: USER_TYPE.SCHOOL.ROLE,
    element: SchoolDashboard,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/teachers`,
    element: SchoolTeachers,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/teachers/:id`,
    element: SchoolTeacherDetails,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/classrooms`,
    element: SchoolClassrooms,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/classrooms/:id`,
    element: SchoolClassroomDetails,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/students`,
    element: SchoolStudents,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/import-students`,
    element: SchoolImportStudents,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/students/:id`,
    element: SchoolStudentDetails,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/general-reports`,
    element: GeneralReports,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/classroom-reports`,
    element: ClassroomReports,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/adapted-courses`,
    element: AdaptedCourses,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/top-10-students`,
    element: TopTenStudents,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/top-weekly-5-students`,
    element: TopWeeklyStudents,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },
  {
    path: `${USER_TYPE.SCHOOL.ROLE}/notifications-center`,
    element: SchoolNotificationCenter,
    roles: [USER_TYPE.SCHOOL.ROLE],
  },

  /* superadmin routes starts here  */
  {
    path: USER_TYPE.SUPERADMIN.ROLE,
    element: SuperAdminDashboard,
    roles: [USER_TYPE.SUPERADMIN.ROLE],
  },
  /* parent routes starts here  */
  {
    path: USER_TYPE.PARENT.ROLE,
    element: B2CPending,
    roles: [USER_TYPE.PARENT.ROLE],
  },
  /* kid routes starts here  */
  {
    path: USER_TYPE.KID.ROLE,
    element: B2CPending,
    roles: [USER_TYPE.KID.ROLE],
  },
];
